<template>
  <div>
    <div class="company" v-if="type === 'company'">
      <div class="company_left">
        <div class="upload-box">
          <upload-image
            :imageUrl.sync="enterpriseInfo.companyLogoLook"
            :saveUrl.sync="enterpriseInfo.companyLogo"
            @uploadSuccess="sureInfo"
          />

          <div class="upload-label" v-if="!enterpriseInfo.companyLogo">
            点击更换
          </div>
        </div>

        <el-form
          :model="enterpriseInfo"
          :inline="true"
          :rules="rulesCompanyInfo"
          ref="rulesCompanyInfo"
          class="companyInfo"
        >
          <div class="info">
            <div>
              <div class="fullName" v-if="!isShowInput">
                <div class="companyFullName">
                  {{ enterpriseInfo.companyFullName || "--" }}
                </div>

                <i class="jr-iconjr-icon-edit1" @click="editClick" />
              </div>

              <div
                class="fullName"
                :class="{
                  hide: !isShowInput
                }"
              >
                <el-form-item prop="companyFullName">
                  <div class="edit-group">
                    <el-input
                      v-model="enterpriseInfo.companyFullName"
                      ref="editCompanyFullName"
                    />

                    <el-button type="primary" size="middle" @click="sureInfo"
                      >保 存</el-button
                    >
                  </div>
                </el-form-item>
              </div>
            </div>

            <div class="updateTime">
              {{ enterpriseInfo.id }}
            </div>
          </div>
        </el-form>
      </div>

      <div class="company_center">
        <div class="company_data">
          <div class="label">
            数据质量
          </div>

          <!-- 数据质量字段缺失 -->
          <div class="value_num">
            {{ enterpriseInfo.dataQuality }}
          </div>
        </div>

        <div class="company_circle">
          <div class="label">
            数据完整度
          </div>

          <div class="circle_content">
            <el-progress
              type="circle"
              :percentage="enterpriseInfo.dataIntegrity"
              :stroke-width="10"
              :width="100"
            ></el-progress>
          </div>
        </div>
      </div>

      <div class="company_right">
        <el-button
          type="primary"
          class="back-btn"
          plain
          @click="backPress"
          icon="ali-icon-back"
        >
          返回上级
        </el-button>

        <div class="company_edit_info">
          <div class="company_edit_item">
            <img src="@/assets/img/user-line.png" alt="" />

            <p>修改人：{{ enterpriseInfo.updateName || "--" }}</p>
          </div>

          <div class="company_edit_item">
            <img src="@/assets/img/update-icon.png" alt="" />

            <p>更新：{{ enterpriseInfo.createTime || "--" }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="company" v-if="type === 'solve'">
      <div class="company_left">
        <div class="cover-box">
          <img :src="solveInfo.coverImage" v-if="solveInfo.coverImage" class="solve-cover">
        </div>

        <el-form
          :model="solveInfo"
          ref="rulesCompanyInfo"
          class="companyInfo"
        >
          <div class="info">
            <div>
              <div class="fullName">
                <div class="companyFullName">
                  {{ solveInfo.solutionName || "--" }}
                </div>
              </div>
            </div>

            <div class="updateTime">
              {{ solveInfo.id }}
            </div>
          </div>
        </el-form>
      </div>

      <div class="company_center">
        <div class="company_data">
          <div class="label">
            数据质量
          </div>

          <!-- 数据质量字段缺失 -->
          <div class="value_num">
            {{ solveInfo.dataQuality }}
          </div>
        </div>

        <div class="company_circle">
          <div class="label">
            数据完整度
          </div>

          <div class="circle_content">
            <el-progress
              type="circle"
              :percentage="Number(solveInfo.solutionDataIntegrity)"
              :stroke-width="10"
              :width="100"
            ></el-progress>
          </div>
        </div>
      </div>

      <div class="company_right">
        <el-button
          type="primary"
          class="back-btn"
          plain
          @click="backPress"
          icon="ali-icon-back"
        >
          返回上级
        </el-button>

        <div class="company_edit_info">
          <div class="company_edit_item">
            <img src="@/assets/img/user-line.png" alt="" />

            <p>修改人：{{ solveInfo.updateName || "--" }}</p>
          </div>

          <div class="company_edit_item">
            <img src="@/assets/img/update-icon.png" alt="" />

            <p>更新：{{ solveInfo.createTime || "--" }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import {
  updateClientEnterprise,
  getClientEnterpriseOne
} from "@/api/customCompany";
import { getSolutionById } from "@/api/solvePlan.js";
// components
import UploadImage from "@/components/UploadImage.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    UploadImage
  },
  props: {
    companyCode: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: "company"
    },
    solveInfo: {
      type: Object,
      default: () => {
        return new Object()
      }
    }
  },
  data() {
    //这里存放数据
    return {
      isShowInput: false,
      enterpriseInfo: {},
      rulesCompanyInfo: {
        companyFullName: [
          { required: true, message: "请输入公司全称", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    console.log('this.companyCode')
    console.log(this.companyCode)
    this.$nextTick(() => {
      if (this.type === "company") {
        this.getInfo();
      }
    });
  },
  methods: {
    backPress() {
      this.$emit("backPress", true);
    },
    editClick() {
      this.isShowInput = true;
      this.$refs.editCompanyFullName?.focus();
    },
    async sureInfo() {
      await this.$refs.rulesCompanyInfo.validate(async valid => {
        if (valid) {
          const res = await updateClientEnterprise(this.enterpriseInfo);
          this.isShowInput = false;
        }
      });
    },
    async getInfo() {
      try {
        const res = await getClientEnterpriseOne({
          id: this.companyCode
        });

        this.enterpriseInfo = res.data;
        console.log('enterpriseInfo----------------', res.data)
      } catch (err) {
        console.error({
          component: "CompanyInfoBar",
          error: err
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .company_left {
    display: flex;
    align-items: center;

    .cover-box {
      width: 80px;
      height: 80px;
      border-radius: 4px;
      background-color: #E6E6E6;
      overflow: hidden;
    }

    .upload-box {
      position: relative;
      border-radius: 4px;
      overflow: hidden;

      .upload-label {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 21px;
        line-height: 21px;
        font-size: 10px;
        color: #ffffff;
        background-color: #15151540;
        text-align: center;
      }
    }

    .solve-cover {
      display: block;
      width: 80px;
      height: 80px;
    }

    .info {
      margin: 8px 0 8px 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .fullName {
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        &.hide {
          width: 0;
          height: 0;
          overflow: hidden;
        }

        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #333333;
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }

  .edit-group {
    display: flex;
    align-items: center;
  }

  .company_center {
    display: flex;

    .label {
      font-size: 16px;
      color: #333333;
    }

    .company_data {
      margin-right: 45px;

      .value_num {
        margin-top: 8px;
        height: 43px;
        line-height: 43px;
        font-size: 22px;
        font-weight: 500;
        text-align: center;
      }
    }

    .company_circle {
      .circle_content {
        margin-top: 8px;
      }
      // .circle_content {
      //   margin-top: 8px;
      //   width: 50px;
      //   height: 50px;
      // }
    }

    .company_circle,
    .company_data {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .company_right {
    display: flex;

    .back-icon {
      width: 18px;
      height: 18px;
    }

    .context {
      line-height: 18px;
    }

    .company_button {
      display: flex;
      align-items: center;
      font-size: 14px;
    }

    .company_edit_info {
      margin-left: 20px;
      font-size: 14px;
      color: #999999;

      .company_edit_item {
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        p {
          height: 20px;
          line-height: 20x;
        }

        img {
          margin-right: 5px;
          width: 14px;
          height: 14px;
        }
      }
    }
  }

  .back-btn {
    display: flex;
    align-items: center;
  }
}
</style>
